<template>
  <v-main class="d-flex flex-column align-center justify-content-between">
    <div class="container">
      <div class="text-center">
        <h1 class="mt-12">
          {{ $t("onMaintenance") }}
        </h1>
        <p>
          {{ $t("onMaintenanceMessage") }}
        </p>
      </div>
      <div>
        <v-img :src="OnMaintenance" max-width="600" />
      </div>
      <v-btn
        class="primary"
        :disabled="timer != 0"
        @click="reload"
        v-if="$domain() !== 'oxebet'"
      >
        <span v-if="timer != 0"> Aguarde {{ timer }} segundos </span>
        <span v-else>
          Tentar Novamente
        </span>
      </v-btn>
    </div>
  </v-main>
</template>

<script>
import OnMaintenance from "./OnMaintenance.svg";
import { injectGTM, injectgTag } from "../../util/analytics"

export default {
  name: "OnMaintenance",
  props: ["seconds"],
  data: () => ({
    OnMaintenance,
    timer: 0,
    _decreaseTimerId: 0,
  }),
  created() {
    if (this.$domain() === 'jogodeourobet') {
      // jogo de ouro gtm
      injectGTM("GTM-T6CFP87");
      injectgTag()
    }

    this.timer = this.seconds;

    this._decreaseTimerId = setInterval(() => {
      this.timer = this.timer - 1;
    }, 1000);
  },
  watch: {
    timer(val) {
      if (val === -1) {
        this.$nextTick(() => {
          this.timer = this.timer + 1;
          clearInterval(this._decreaseTimerId);
        });
      }
    },
  },
  methods: {
    reload() {
      window.location.reload();
    },
  },
};
</script>
<style scoped>
.container {
  display: flex;
  height: 70vh;
  flex-direction: column;
  justify-content: space-between;
}
</style>
